import { RefString, RefNumber } from "@tblabs/truffle";
import { RawGalleryItem } from "./RawGalleryItem";


export class GalleryItem
{
    public OriginalUrl = new RefString();
    public NormalizedUrl = new RefString();
    public ThumbnailUrl = new RefString();
    public MiniUrl = new RefString();
    public Description = new RefString();
    public XOffset = new RefNumber();
    public YOffset = new RefNumber();

    constructor(raw: Partial<RawGalleryItem>)
    {
        this.OriginalUrl.value = raw.OriginalUrl || "";
        this.NormalizedUrl.value = raw.NormalizedUrl || "";
        this.ThumbnailUrl.value = raw.ThumbnailUrl || "";
        this.MiniUrl.value = raw.MiniUrl || "";
        this.Description.value = raw.Description || "";
        this.XOffset.value = raw.XOffset || 0;
        this.YOffset.value = raw.YOffset || 0;
    }
}
